module.exports = __webpack_public_path__ + "static/media/Poweredby_logo.9812fa60.png";